<div class="flex md:p-4 p-1 flex-col justify-start basis-full app-full-height">
  <h1 class="xl:flex hidden py-6">Your Transport Jobs</h1>

  <div class="flex flex-row justify-start items-start w-full gap-x-2">
    <div class="flex flex-col justify-start items-stretch basis-full flex-shrink xl:flex"
      [class.hidden]="selectedId() !== null">
      <table mat-table [dataSource]="jobs$ | async" class="hidden xl:table w-full">
        <tr mat-header-row *matHeaderRowDef="lgColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: lgColumns" [style]="{
            'background-color': row.id === selectedId() ? '#f1fff1' : ''
          }" class="cursor-pointer" (click)="selectJob(row)"></tr>

        <ng-container matColumnDef="due">
          <th mat-header-cell *matHeaderCellDef>Due</th>
          <td mat-cell *matCellDef="let row">{{ row.due | date: 'short' }}</td>
        </ng-container>

        <ng-container matColumnDef="customer">
          <th mat-header-cell *matHeaderCellDef>Customer</th>
          <td mat-cell *matCellDef="let row">{{ row.customer }}</td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Location</th>
          <td mat-cell *matCellDef="let row">
            <div class="flex flex-row justify-start items-center gap-x-2">
              <p>{{ row.location }}</p>
              <app-google-maps-link [placeId]="row.google_place_id" [address]="row.location"></app-google-maps-link>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row">{{ row.type | titlecase }}</td>
        </ng-container>

        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef>Items</th>
          <td mat-cell *matCellDef="let row">
            {{ row.items | deliveryItemsList }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row"></td>
        </ng-container>
      </table>

      <table mat-table [dataSource]="jobs$ | async" class="xl:hidden w-full">
        <tr mat-header-row *matHeaderRowDef="smColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: smColumns"></tr>
        <ng-container matColumnDef="compact">
          <th mat-header-cell *matHeaderCellDef>
            <h1>Your Delivery Jobs</h1>
          </th>
          <td mat-cell *matCellDef="let row">
            <app-compact-delivery-job [job]="row" (showJobDetails)="selectJob($event)"></app-compact-delivery-job>
          </td>
        </ng-container>
      </table>
    </div>

    @if (selectedId()) {
    <div class="flex flex-col justify-start items-stretch basis-2/5 flex-shrink-0 flex-grow p-2">
      <mat-card>
        <mat-card-content>
          <app-delivery-job-details (close)="selectJob(null)" [jobId]="selectedId()"></app-delivery-job-details>
        </mat-card-content>
      </mat-card>
    </div>
    }
  </div>
</div>